<shrd-uic-left-card
  #cardsContainer
  (backdropClicked)="resetServiceState()"
  (closed)="resetCards()"
  class="burger-menu-wrapper"
  *ngIf="isBrowser"
>
  <shrd-uic-left-card-content
    #primaryContentCard
    [id]="menuCards.PRIMARY_CONTENT"
    [currentCard]="currentCardId"
    [bodyRef]="homeBody"
    [scrollbarEnabled]="false"
  >
    <ng-template #homeBody>
      <div *ngIf="showAccountInfo" class="mb-0 py-1 grey-bg">
        <shrd-pf-ft-user-wrapper
          [loggedUserTemplateRef]="loggedUserTemplate"
          [userData]="userData"
          [showProfileIcon]="false"
          class="pe-0"
        >
          <ng-template #loggedUserTemplate>
            <shrd-pf-ft-header-user-account-wrapper
              *ngIf="userData.isRegistered && !userData.isAccountSync; else pendingUserTemplate"
              #userAccountWrapper
              [userAccount]="userData?.selectedAccount"
              [omitUserTitle]="true"
              [canSwitchAccount]="userData?.accounts?.length > 1"
              (toggleAccountSelection)="openAccountSelectionCard()"
            ></shrd-pf-ft-header-user-account-wrapper>
            <ng-template #pendingUserTemplate>
              <div class="m-0 ps-5 text text-primary text-uppercase bl-h-3">
                <span>
                  {{
                    (userData.isAccountSync ? 'header.account.accountSync' : 'header.account.registrationPending')
                      | i18next
                  }}
                </span>
              </div>
            </ng-template>
          </ng-template>
        </shrd-pf-ft-user-wrapper>
      </div>
      <shrd-pf-ft-burger-menu-primary-content
        [isAccountMenu]="showAccountInfo"
        [userData]="userData"
        [metaNavItems]="metaNavItems"
        [primaryNavItems]="navItems$ | async"
        [showLogout]="showLogoutOnBottom"
        (menuSelected)="activateMenuItem($event)"
      ></shrd-pf-ft-burger-menu-primary-content>
    </ng-template>
  </shrd-uic-left-card-content>

  <shrd-uic-left-card-content
    #secondaryContentCard
    [id]="menuCards.SECONDARY_CONTENT"
    [currentCard]="currentCardId"
    [headerRef]="mainContentHeader"
    [bodyRef]="mainContentBody"
    [footerRef]="mainContentFooter"
    [scrollbarEnabled]="false"
  >
    <ng-template #mainContentHeader>
      <shrd-pf-ft-burger-menu-secondary-header
        *ngIf="userData?.isLoggedIn || !activeState?.selectedItem?.postAuthOnly"
        [selectedItem]="activeState?.selectedItem"
      ></shrd-pf-ft-burger-menu-secondary-header>
    </ng-template>

    <ng-template #mainContentBody>
      <shrd-pf-ft-burger-menu-secondary-content
        [menuItem]="activeState?.selectedItem"
        [userData]="userData"
        (accountChanged)="onAccountChanged($event)"
      ></shrd-pf-ft-burger-menu-secondary-content>
    </ng-template>

    <ng-template #mainContentFooter>
      <shrd-pf-ft-burger-menu-secondary-footer
        (closeSecondaryMenu)="closeContentCard()"
        [userData]="userData"
        [menuItem]="activeState?.selectedItem"
      ></shrd-pf-ft-burger-menu-secondary-footer>
    </ng-template>
  </shrd-uic-left-card-content>
</shrd-uic-left-card>

<button
  (click)="openMenu()"
  [attr.aria-label]="'header.icon.hamburger' | i18next"
  class="m-0 color-dark"
  shrdUicButton
  variant="tertiaryMinorBorderless"
>
  <shrd-uic-svg-icon icon="hamburger" [inheritColor]="true"></shrd-uic-svg-icon>
</button>
